import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'

import { setRedirectAfterAuth } from '../../../modules/auth/actions/creators'

import {
  displayProfileModal,
  setProfileModalPage,
  setNotificationCount,
  setEmailVerificationStatus,
  setAccountStatus,
  setTransportationMall,
  setPrimaryInfo,
} from '../../../modules/profile/actions/creators'

import { setDisplayAppModal } from '../../../modules/explore/actions/creators'

import { setTicketCount } from '../../../modules/watch/actions/creators'

import { setLoyaltyPoints } from '../../../modules/loyalty/actions/creators'
import { setFeatureStatus } from '../../../modules/dashboard/actions/creators'

import {
  waitRenderServer,
  renderServer,
} from '../../../modules/ssr/actions/creators'

import ProfilePage from '../components/ProfilePage/ProfilePage'

const mapStateToProps = reduxState => {
  const { auth, profile, watch, dashboard, loyalty, explore } = reduxState

  const { selectedMallSlug } = explore

  const { accessToken } = auth

  const {
    primaryInfo,
    showProfileModal,
    profileModalPage,
    notificationCount,
    emailVerificationStatus,
    advanceAccount,
    transportationMall,
  } = profile

  const { ticketCount } = watch

  const { featureStatus } = dashboard

  const { loyaltyPoints } = loyalty

  return {
    accessToken,
    primaryInfo,
    showProfileModal,
    profileModalPage,
    notificationCount,
    transportationMall,
    emailVerificationStatus,
    ticketCount,
    advanceAccount,
    featureStatus,
    loyaltyPoints,
    selectedMallSlug,
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setAccountStatus,
      displayProfileModal,
      setProfileModalPage,
      setNotificationCount,
      setEmailVerificationStatus,
      setTransportationMall,
      setTicketCount,
      setRedirectAfterAuth,
      setDisplayAppModal,
      setLoyaltyPoints,
      push,
      waitRenderServer,
      renderServer,
      setFeatureStatus,
      setPrimaryInfo,
    },
    dispatch,
  )

const ConnectedProfilePage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ProfilePage)

export default ConnectedProfilePage
